export default __webpack_public_path__ + "static/media/genericCardImage.7fa77b6e.svg";